import { useEffect, useState } from "react";
import { api, store } from "./store.ts";

/**
 * Whether the server has a model (S61 § 11): without one there is no „Deutsch ✓“ and no guided flow,
 * only translating by hand. Asked once per business; until the answer, as if there were one (most
 * servers have it), so that nothing shows and then goes.
 */
const known = new Map<string, boolean>();
const asking = new Map<string, Promise<void>>();

export const modelAvailable = (): boolean => known.get(store.session?.workspaceId ?? "") ?? true;

/** Kept from an answer of `/api/texts` (the jobs ask it anyway). */
export function noteModel(available: boolean) {
  known.set(store.session?.workspaceId ?? "", available);
  window.dispatchEvent(new Event("speisekarte:model"));
}

export function useModel(): boolean {
  const [, setTick] = useState(0);
  const workspace = store.session?.workspaceId ?? "";
  useEffect(() => {
    const on = () => setTick((n) => n + 1);
    window.addEventListener("speisekarte:model", on);
    if (!known.has(workspace) && !asking.has(workspace) && workspace)
      asking.set(
        workspace,
        api<{ available: boolean }>("/api/texts")
          .then((r) => noteModel(r.available))
          .catch(() => undefined)
          .finally(() => asking.delete(workspace)),
      );
    return () => window.removeEventListener("speisekarte:model", on);
  }, [workspace]);
  return modelAvailable();
}
